import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import PrivateRoute from "../features/auth/PrivateRoute";
import AppLayout from "../layouts/AppLayout";

/* ===============================
   🔓 RUTAS PÚBLICAS
================================ */

// Auth
import LoginPag from "../features/auth/LoginPag";

// Landing / Menú
import MenuLanding from "../features/menuDigital/MenuLanding";
import MenuDigital from "../features/menuDigital/MenuDigital";

// Pedido público (CLIENTE)
import PedidoLista from "../features/pedidos/publico/pages/PedidoLista";
import PedidoProducto from "../features/pedidos/publico/pages/PedidoProducto";
import PedidoCarrito from "../features/pedidos/publico/pages/PedidoCarrito";

/* ===============================
   🔐 RUTAS PROTEGIDAS (ADMIN)
================================ */

// Dashboard
import Dashboard from "../features/dashboard/Dashboard";

// Facturas
import FacturasPag from "../features/facturas/FacturasPag";
import FacturarPedido from "../features/facturas/FacturarPedido";
import HistorialFacturasPag from "../features/facturas/HistorialFacturasPag";
import FacturaDetallePag from "../features/facturas/FacturaDetallePag";

// Pedidos (ADMIN)
import PedidosPag from "../features/pedidos/PedidosPag";
import PedidoCrear from "../features/pedidos/PedidoCrear";
import HistorialPedidosPag from "../features/pedidos/HistorialPedidosPag";
import PedidoDetallePag from "../features/pedidos/PedidoDetallePag";

// Mesas / Productos
import ProductosPag from "../features/productos/ProductosPag";
import CategoriaList from "../features/categorias/CategoriaList";

// Usuarios
import UsuarioList from "../features/usuarios/UsuarioList";
import UsuarioCrear from "../features/usuarios/UsuarioCrear";

// Inventario
import InsumoList from "../features/inventario/InsumoList";
import MovimientoInventarioPage from "../features/inventario/MovimientoInventarioPage";
import RecetaProductoPage from "../features/inventario/RecetaProductoPage";

export default function AppRouter() {
  return (
    <Router>
      <Routes>

        {/* ===============================
            🔓 PÚBLICAS
        ================================ */}

        {/* Landing */}
        <Route path="/" element={<MenuLanding />} />

        {/* Menú digital (QR mesas) */}
        <Route path="/menu" element={<MenuDigital />} />

        {/* Pedido público (CLIENTE) */}
        <Route path="/pedido" element={<PedidoLista />} />
        <Route path="/pedido/producto/:id" element={<PedidoProducto />} />
        <Route path="/pedido/carrito" element={<PedidoCarrito />} />

        {/* Login */}
        <Route path="/login" element={<LoginPag />} />

        {/* ===============================
            🔐 PROTEGIDAS (ADMIN)
        ================================ */}
        <Route element={<PrivateRoute />}>
          <Route element={<AppLayout />}>

            {/* Dashboard */}
            <Route path="/dashboard" element={<Dashboard />} />

            {/* Usuarios */}
            <Route path="/usuarios" element={<UsuarioList />} />
            <Route path="/usuarios/crear" element={<UsuarioCrear />} />

            {/* Facturas */}
            <Route path="/facturas" element={<FacturasPag />} />
            <Route path="/facturas/historial" element={<HistorialFacturasPag />} />
            <Route path="/facturas/:id" element={<FacturaDetallePag />} />
            <Route path="/facturar/:pedidoId" element={<FacturarPedido />} />

            {/* Pedidos (ADMIN) */}
            <Route path="/pedidos" element={<PedidosPag />} />
            <Route path="/pedidos/nuevo" element={<PedidoCrear />} />
            <Route path="/pedidos/historial" element={<HistorialPedidosPag />} />
            <Route path="/pedidos/:id" element={<PedidoDetallePag />} />

            {/* Mesas / Productos */}
            <Route path="/productos" element={<ProductosPag />} />
            <Route path="/admin/categorias" element={<CategoriaList />} />

            {/* Inventario */}
            <Route path="/inventario/insumos" element={<InsumoList />} />
            <Route path="/inventario/movimientos" element={<MovimientoInventarioPage />} />
            <Route path="/inventario/recetas" element={<RecetaProductoPage />} />

          </Route>
        </Route>

        {/* ===============================
            Fallback
        ================================ */}
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>
    </Router>
  );
}
